var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6236 8.31008C21.5266 8.40753 21.4497 8.52347 21.3972 8.65121C21.3447 8.77895 21.3176 8.91597 21.3176 9.05436C21.3176 9.19274 21.3447 9.32976 21.3972 9.4575C21.4497 9.58524 21.5266 9.70118 21.6236 9.79863L26.3813 14.6207H2.03428C1.75997 14.6207 1.4969 14.7311 1.30293 14.9277C1.10897 15.1243 1 15.391 1 15.669C1 15.947 1.10897 16.2136 1.30293 16.4102C1.4969 16.6068 1.75997 16.7173 2.03428 16.7173H26.3606L21.6236 21.5079C21.431 21.7043 21.3228 21.97 21.3228 22.2469C21.3228 22.5239 21.431 22.7895 21.6236 22.986C21.8174 23.1812 22.0795 23.2908 22.3528 23.2908C22.626 23.2908 22.8881 23.1812 23.0819 22.986L29.66 16.3189C29.7485 16.2328 29.8189 16.1295 29.8671 16.0151C29.9152 15.9007 29.94 15.7776 29.94 15.6533C29.94 15.5289 29.9152 15.4058 29.8671 15.2914C29.8189 15.177 29.7485 15.0737 29.66 14.9876L23.0923 8.31008C22.9961 8.21183 22.8817 8.13384 22.7557 8.08062C22.6297 8.0274 22.4945 8 22.3579 8C22.2214 8 22.0862 8.0274 21.9602 8.08062C21.8341 8.13384 21.7197 8.21183 21.6236 8.31008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.a57027f78c8de66cf7adc1824cd1c019.svg";
export { ForwardRef as ReactComponent };